import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '古古漫画网',
  url: 'https://www.gugumanga.com',
  description: '古古漫画网追更连载实时更新，热门国漫日漫韩漫每日更新，免费全集下拉式阅读，人气漫画一网打尽。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.gugumanga.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '古古漫画网',
  url: 'https://www.gugumanga.com',
  description: '古古漫画网是国内领先的漫画在线阅读平台，提供国漫、日漫、韩漫免费全集下拉式阅读服务。',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@gugumanga.com',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryNav />
          <FeaturedSection />
          <LatestSection />
          <RankingSection />
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}